module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('div', {
    class: _vm.isLogin ? 'white' : 'primary',
    attrs: {
      "id": "blaueLeiste"
    }
  }), _vm._v(" "), (!_vm.isLogin) ? _c('v-navigation-drawer', {
    attrs: {
      "disable-resize-watcher": "",
      "app": "",
      "clipped": _vm.$vuetify.breakpoint.lgAndUp
    },
    model: {
      value: (_vm.sideNav),
      callback: function($$v) {
        _vm.sideNav = $$v
      },
      expression: "sideNav"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": "",
      "nav": ""
    }
  }, [_vm._l((_vm.mainMenu), function(item) {
    return (item.beta === false || _vm.$vars.beta) ? _c('v-list-item', {
      key: item.title,
      staticClass: "hidden-sm-and-up",
      attrs: {
        "to": item.link,
        "link": ""
      }
    }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n            " + _vm._s(item.title) + "\n          ")])], 1)], 1) : _vm._e()
  }), _vm._v(" "), _c('v-list-item', {
    staticClass: "hidden-xs-only",
    attrs: {
      "link": "",
      "to": "/"
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Home")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "pb-1"
  }), _vm._v(" "), _vm._l((_vm.sideMenu), function(item) {
    return _c('v-list-item', {
      key: item.link,
      attrs: {
        "to": item.link,
        "link": ""
      }
    }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.title))])], 1)], 1)
  })], 2), _vm._v(" "), _c('v-btn', {
    staticClass: "caption",
    attrs: {
      "disabled": "",
      "text": "",
      "block": ""
    }
  }, [_vm._v("Korpodesk " + _vm._s(_vm.$vars.version))]), _vm._v(" "), _c('v-btn', {
    staticClass: "caption",
    attrs: {
      "disabled": "",
      "text": "",
      "block": ""
    }
  }, [_vm._v(_vm._s(_vm.$vars.versionDatum))])], 1) : _vm._e(), _vm._v(" "), _c('v-navigation-drawer', {
    attrs: {
      "disable-resize-watcher": "",
      "right": "",
      "app": "",
      "clipped": _vm.$vuetify.breakpoint.lgAndUp,
      "width": "90%"
    },
    model: {
      value: (_vm.showMenuMobile),
      callback: function($$v) {
        _vm.showMenuMobile = $$v
      },
      expression: "showMenuMobile"
    }
  }, [_c('v-list-item', [(_vm.bild) ? _c('v-avatar', {
    staticClass: "ma-2",
    attrs: {
      "color": "primary",
      "size": "36"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.bild
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "ml-2 headline"
  }, [_vm._v(_vm._s(_vm.name))])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showMenuMobile = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.sideMenu.length === 0) ? _c('v-list', {
    attrs: {
      "dense": "",
      "nav": ""
    }
  }, _vm._l((_vm.mainMenu), function(item) {
    return (item.beta === false || _vm.$vars.beta) ? _c('v-list-item', {
      key: item.title,
      staticClass: "hidden-sm-and-up",
      attrs: {
        "to": item.link,
        "link": ""
      }
    }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n            " + _vm._s(item.title) + "\n          ")])], 1)], 1) : _vm._e()
  }), 1) : _c('v-list', {
    attrs: {
      "dense": "",
      "nav": ""
    }
  }, [_c('v-list-item', {
    attrs: {
      "link": "",
      "to": "/"
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Home")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "pb-1"
  }), _vm._v(" "), _vm._l((_vm.sideMenu), function(item) {
    return _c('v-list-item', {
      key: item.link,
      attrs: {
        "to": item.link,
        "link": ""
      }
    }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.title))])], 1)], 1)
  })], 2), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": "",
      "nav": ""
    }
  }, [_c('v-divider', {
    staticClass: "pb-1"
  }), _vm._v(" "), _vm._l((_vm.subMenu), function(item) {
    return _c('v-list-item', {
      key: item.title,
      on: {
        "click": function($event) {
          return _vm.goTo(item.link)
        }
      }
    }, [(_vm.bild) ? _c('v-avatar', {
      staticClass: "ma-2",
      attrs: {
        "color": "primary",
        "size": "48"
      }
    }, [_c('img', {
      attrs: {
        "src": '/static/menu-icon/' + item.bild + '.png',
        "alt": item.bild
      }
    })]) : _vm._e(), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.title))])], 1)], 1)
  }), _vm._v(" "), _c('v-divider', {
    staticClass: "pb-1"
  }), _vm._v(" "), (this.$vars.verbindung === 'rbo') ? _c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.showChargenUndAemter = true
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("groups")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Chargen & Ämter")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.showHelp = true
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("help")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Hilfe")])], 1)], 1), _vm._v(" "), (_vm.$getCurrentBbr() === 'PBChUyAy7HWowQR4HlP3') ? _c('div', [_c('v-divider'), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.showEinstellungen = true
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Einstellungen")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-chip', {
    staticClass: "green",
    attrs: {
      "label": "",
      "small": "",
      "dark": ""
    }
  }, [_vm._v("Admin")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.onLogout
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("exit_to_app")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Abmelden")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-center grey--text"
  }, [_vm._v("\n        Korpodesk " + _vm._s(_vm.$vars.version) + " | " + _vm._s(_vm.$filters.date(_vm.$vars.versionDatum, "DD.MM.YYYY")) + "\n      ")])], 2)], 1), _vm._v(" "), (!_vm.isLogin) ? _c('v-app-bar', {
    staticClass: "primary",
    attrs: {
      "dark": !_vm.isHomePage,
      "app": "",
      "extended": "",
      "fade-img-on-scroll": _vm.isHomePage,
      "shrink-on-scroll": _vm.isHomePage,
      "extension-height": _vm.extensionHeight,
      "clipped-left": _vm.$vuetify.breakpoint.lgAndUp,
      "clipped-right": _vm.$vuetify.breakpoint.lgAndUp
    },
    scopedSlots: _vm._u([(_vm.isHomePage) ? {
      key: "img",
      fn: function() {
        return [_c('v-img', {
          staticClass: "white d-none d-md-flex",
          attrs: {
            "contain": "",
            "src": _vm.headerImage,
            "height": "200"
          },
          scopedSlots: _vm._u([{
            key: "placeholder",
            fn: function() {
              return [_c('v-row', {
                staticClass: "fill-height ma-0",
                attrs: {
                  "align": "center",
                  "justify": "center"
                }
              }, [_c('v-progress-circular', {
                attrs: {
                  "indeterminate": "",
                  "color": "grey lighten-5"
                }
              })], 1)]
            },
            proxy: true
          }], null, false, 4034393411)
        }), _vm._v(" "), _c('v-img', {
          staticClass: "white hidden-xs-only hidden-lg-and-up",
          attrs: {
            "src": _vm.headerImage,
            "height": "200"
          }
        }), _vm._v(" "), _c('v-img', {
          staticClass: "white hidden-sm-and-up",
          attrs: {
            "src": _vm.headerImage,
            "height": "132"
          }
        })]
      },
      proxy: true
    } : null, (_vm.userIsAuthenticated) ? {
      key: "extension",
      fn: function() {
        return [_c('v-row', {
          staticClass: "pa-0 ma-0 hidden-md-and-down"
        }, [_c('v-col', {
          staticClass: "pa-0 ma-0 text-center",
          attrs: {
            "cols": "12"
          }
        }, _vm._l((_vm.mainMenu), function(item) {
          return (item.beta === false || _vm.$vars.beta) ? _c('v-btn', {
            key: item.title,
            staticClass: "mx-1 rounded-lg",
            attrs: {
              "text": "",
              "to": item.link,
              "dark": _vm.isHomePage
            }
          }, [_c('span', {
            staticClass: "pl-2"
          }, [_vm._v(_vm._s(item.title)), _c('br'), (item.beta) ? _c('v-chip', {
            staticClass: "green",
            attrs: {
              "label": "",
              "x-small": "",
              "dark": ""
            }
          }, [_vm._v("BETA")]) : _vm._e()], 1)]) : _vm._e()
        }), 1)], 1)]
      },
      proxy: true
    } : null], null, true)
  }, [(_vm.userIsAuthenticated && _vm.sideMenu.length > 0) ? _c('v-app-bar-nav-icon', {
    staticClass: "hidden-xs-only"
  }, [_c('v-icon', {
    on: {
      "click": function($event) {
        return _vm.toggleSideNav()
      }
    }
  }, [_vm._v("menu")])], 1) : _vm._e(), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-app-bar-nav-icon', {
    staticClass: "ml-1"
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [(_vm.$vars.beta) ? _c('v-chip', _vm._g({
          staticClass: "green",
          attrs: {
            "label": "",
            "small": "",
            "dark": ""
          }
        }, on), [_vm._v("BETA")]) : _vm._e()]
      }
    }], null, false, 2024530956)
  }, [_vm._v(" "), _c('span', [_c('v-card', {
    staticClass: "transparent",
    attrs: {
      "flat": "",
      "dark": "",
      "width": "200px"
    }
  }, [_vm._v("\n            Dies ist die Betaversion von Korpodesk. Einige neue Funktionen sind dadurch verwendbar und werden mit dem\n            grünen BETA Zeichen angekündigt.\n          ")])], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.$vars.beta) ? _c('v-app-bar-nav-icon', {
    staticClass: "ml-4 mr-3"
  }, [_c('v-chip', {
    staticClass: "green",
    attrs: {
      "label": "",
      "small": "",
      "dark": ""
    }
  }, [_vm._v(_vm._s(_vm.$vars.verbindung))])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer', {
    staticClass: "hidden-sm-and-up"
  }), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.route))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('bundesbruderSucheShort', {
    staticClass: "hidden-sm-and-down",
    attrs: {
      "dark": _vm.isHomePage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "hidden-sm-and-down rounded-lg mx-1 mt-1",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.goTo()
            }
          }
        }, on), [_c('v-icon', [_vm._v("home")])], 1)]
      }
    }], null, false, 1450401724)
  }, [_vm._v(" "), _c('span', [_vm._v("Home")])]) : _vm._e(), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-btn', {
    staticClass: "hidden-xs-only rounded-lg mt-1",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        (_vm.showMenu = true) && _vm.getSubMenu()
      }
    }
  }, [_c('v-icon', [_vm._v("apps")])], 1) : _vm._e(), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-app-bar-nav-icon', {
    staticClass: "hidden-sm-and-up"
  }, [_c('v-icon', {
    on: {
      "click": function($event) {
        (_vm.showMenuMobile = true) && _vm.getSubMenu()
      }
    }
  }, [_vm._v("apps")])], 1) : _vm._e(), _vm._v(" "), _c('v-menu', {
    attrs: {
      "absolute": "",
      "position-x": _vm.x,
      "position-y": 54,
      "min-width": _vm.subMenu.length > 12 ? '752px' : '376px',
      "max-width": _vm.subMenu.length > 12 ? '752px' : '376px',
      "close-on-click": "",
      "max-height": "calc(100vh - 90px)"
    },
    model: {
      value: (_vm.showMenu),
      callback: function($$v) {
        _vm.showMenu = $$v
      },
      expression: "showMenu"
    }
  }, [_c('v-card', [_c('v-list-item', [(_vm.bild) ? _c('v-avatar', {
    staticClass: "ma-2",
    attrs: {
      "color": "primary",
      "size": "48"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.bild
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "ml-2 headline"
  }, [_vm._v(_vm._s(_vm.name))])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-row', {
    staticClass: "pa-0 ma-0"
  }, _vm._l((_vm.subMenu), function(item) {
    return _c('v-col', {
      key: item.title,
      staticClass: "pa-0 ma-0 pt-1 pb-1 text-center",
      attrs: {
        "cols": _vm.subMenu.length > 12 ? 2 : 4
      }
    }, [_c('v-btn', {
      staticClass: "text-center",
      attrs: {
        "text": "",
        "width": "110px",
        "height": "110px"
      },
      on: {
        "click": function($event) {
          return _vm.goTo(item.link)
        }
      }
    }, [_c('v-row', {
      staticClass: "pa-0 ma-0"
    }, [_c('v-col', {
      staticClass: "pa-0 ma-0 pb-2",
      attrs: {
        "cols": "12"
      }
    }, [_c('v-avatar', {
      attrs: {
        "size": 64,
        "color": "transparent"
      }
    }, [_c('img', {
      attrs: {
        "src": '/static/menu-icon/' + item.bild + '.png',
        "alt": item.bild
      }
    })])], 1), _vm._v(" "), _c('v-col', {
      staticClass: "pa-0 ma-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('span', {
      staticClass: "caption font-weight-light"
    }, [_vm._v(_vm._s(item.title))])])], 1)], 1)], 1)
  }), 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-divider'), _vm._v(" "), (this.$vars.verbindung === 'rbo') ? _c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.showChargenUndAemter = true
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("groups")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Chargen & Ämter")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.showHelp = true
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("help")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Hilfe")])], 1)], 1), _vm._v(" "), (_vm.getAdmins.includes(_vm.$getCurrentBbr()) || _vm.$getCurrentBbr() === 'PBChUyAy7HWowQR4HlP3') ? _c('div', [_c('v-divider'), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.showEinstellungen = true
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Einstellungen")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-chip', {
    staticClass: "green",
    attrs: {
      "label": "",
      "small": "",
      "dark": ""
    }
  }, [_vm._v("Admin")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": _vm.onLogout
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("exit_to_app")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Abmelden")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-center grey--text"
  }, [_vm._v(" Korpodesk " + _vm._s(_vm.$vars.version) + " ")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-main', {
    staticClass: "grey lighten-4",
    attrs: {
      "app": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-bottom-navigation', {
    staticClass: "mb-4 hidden-sm-and-up",
    attrs: {
      "app": "",
      "fixed": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "to": "/"
    }
  }, [_c('span', [_vm._v("Home")]), _c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/veranstaltungen"
    }
  }, [_c('span', [_vm._v("Kalender")]), _c('v-icon', [_vm._v("event")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/bbrbbr"
    }
  }, [_c('span', [_vm._v("BbrBbr")]), _c('v-icon', [_vm._v("group")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/rechnungen"
    }
  }, [_c('span', [_vm._v("Rechnungen")]), _c('v-icon', [_vm._v("receipt_long")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "white hidden-sm-and-up",
    attrs: {
      "id": "weißeLeiste"
    }
  }), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-bottom-navigation', {
    staticClass: "hidden-lg-and-up hidden-xs-only",
    attrs: {
      "shift": _vm.sideMenu.length > 8,
      "app": "",
      "fixed": "",
      "color": "primary"
    }
  }, [_vm._l((_vm.mainMenu), function(item) {
    return (_vm.sideMenu.length === 0) ? _c('v-btn', {
      key: item.link,
      attrs: {
        "to": item.link
      }
    }, [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('v-icon', [_vm._v(_vm._s(item.icon))])], 1) : _vm._e()
  }), _vm._v(" "), (_vm.sideMenu.length > 0) ? _c('v-btn', {
    attrs: {
      "to": "/"
    }
  }, [_c('span', [_vm._v("Home")]), _vm._v(" "), _c('v-icon', [_vm._v("home")])], 1) : _vm._e(), _vm._v(" "), (_vm.sideMenu.length > 0) ? _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.sideMenu), function(item) {
    return _c('v-tooltip', {
      key: item.link,
      attrs: {
        "top": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-btn', _vm._g({
            attrs: {
              "to": item.link
            }
          }, on), [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('v-icon', [_vm._v(_vm._s(item.icon))])], 1)]
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(item.title))])])
  })], 2) : _vm._e(), _vm._v(" "), _c('einstellungen', {
    attrs: {
      "visible": _vm.showEinstellungen
    },
    on: {
      "update:visible": function($event) {
        _vm.showEinstellungen = $event
      },
      "close": function($event) {
        _vm.showEinstellungen = false
      }
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "50%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showHelp),
      callback: function($$v) {
        _vm.showHelp = $$v
      },
      expression: "showHelp"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        Hilfe\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showHelp = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-alert', [_vm._v("\n          Du brauchst Hilfe oder hast einen Fehler gefunden? "), _c('br'), _vm._v("\n          Bitte beschreibe das Problem/den Fehler möglichst genau, sodass ich dir Helfen oder die Funktion verbessern\n          kann. Vielen Dank!\n        ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Auf welcher Seite tritt der Fehler auf?",
      "outlined": ""
    },
    model: {
      value: (_vm.fehler.seite),
      callback: function($$v) {
        _vm.$set(_vm.fehler, "seite", $$v)
      },
      expression: "fehler.seite"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "label": "Beschreibung",
      "outlined": ""
    },
    model: {
      value: (_vm.fehler.beschreibung),
      callback: function($$v) {
        _vm.$set(_vm.fehler, "beschreibung", $$v)
      },
      expression: "fehler.beschreibung"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showHelp = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.sendFehler()
      }
    }
  }, [_vm._v("Senden")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "100%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showChargenUndAemter),
      callback: function($$v) {
        _vm.showChargenUndAemter = $$v
      },
      expression: "showChargenUndAemter"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        Chargen & Ämter\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showChargenUndAemter = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-row', {
    staticClass: "hidden-sm-and-down",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "3"
    }
  }, [_c('chargen', {
    staticClass: "mt-2 pb-1",
    attrs: {
      "vorstand": "Chargen",
      "showTitle": true
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "3"
    }
  }, [_c('chargen', {
    staticClass: "mt-2 pb-1",
    attrs: {
      "vorstand": "AHV-Vorstand",
      "showTitle": true
    }
  }), _vm._v(" "), _c('chargen', {
    staticClass: "mt-2 pb-1",
    attrs: {
      "vorstand": "HBV-Vorstand",
      "showTitle": true
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "3"
    }
  }, [_c('chargen', {
    staticClass: "mt-2 pb-1",
    attrs: {
      "vorstand": "Kommissionen",
      "showTitle": true
    }
  }), _vm._v(" "), _c('chargen', {
    staticClass: "mt-2 pb-1",
    attrs: {
      "vorstand": "Zirkel",
      "showTitle": true
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "3"
    }
  }, [_c('chargen', {
    staticClass: "mt-2 pb-1",
    attrs: {
      "vorstand": "Ämter",
      "showTitle": true
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "hidden-md-and-up"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-expansion-panels', [_c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("Chargen Aktivitas")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('chargen', {
    staticClass: "mt-2 pb-1",
    attrs: {
      "showTitle": false,
      "vorstand": "Aktivitas"
    }
  })], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("Chargen AHV")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('chargen', {
    staticClass: "mt-2 pb-1",
    attrs: {
      "showTitle": false,
      "vorstand": "AHV-Vorstand"
    }
  })], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("Chargen HBV")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('chargen', {
    staticClass: "mt-2 pb-1",
    attrs: {
      "showTitle": false,
      "vorstand": "HBV-Vorstand"
    }
  })], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("Kommissionen")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('chargen', {
    staticClass: "mt-2 pb-1",
    attrs: {
      "showTitle": false,
      "vorstand": "Kommissionen"
    }
  })], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("Zirkel")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('chargen', {
    staticClass: "mt-2 pb-1",
    attrs: {
      "showTitle": false,
      "vorstand": "Zirkel"
    }
  })], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', {
    staticClass: "title"
  }, [_vm._v("Ämter")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('chargen', {
    staticClass: "mt-2 pb-1",
    attrs: {
      "showTitle": false,
      "vorstand": "Ämter"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mb-6 mb-md-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showChargenUndAemter = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1), _vm._v(" "), _c('dialogNachricht'), _vm._v(" "), _c('snackbar'), _vm._v(" "), _c('dialogError')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e5251e90"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 816
// module chunks = 15